import { render, staticRenderFns } from "./ad-preview-table.vue?vue&type=template&id=40bcad24&scoped=true&"
import script from "./ad-preview-table.vue?vue&type=script&lang=js&"
export * from "./ad-preview-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcad24",
  null
  
)

export default component.exports